import dayjs from 'dayjs'

import type { Dayjs } from 'dayjs'

export const getTodayDate = (): Dayjs => dayjs()
export const getTomorrowDate = (): Dayjs => dayjs().set('date', dayjs().get('date') + 1)
export const getDate = (day: number): Dayjs => dayjs().set('date', dayjs().get('date') + day)
export const getDayOfCurrentWeek = (day: number): Dayjs => dayjs().day(day)
